import React from "react";
import cn from "classnames";
import styles from "./Head.module.sass";
import { Link } from "react-router-dom";
import Icon from "../../../../components/Icon";
import Loader from "../../../../components/Loader";

const Head = ({ className, data, loading, save, gotoStripe, onClose }) => {
	return (
		<div className={cn(styles.head, className)}>
			<div className={styles.user}>
				<div className={styles.avatar}>
					<img
						src={data.avatar || "/images/content/avatar-1.jpg"}
						alt="Avatar"
					/>
				</div>
				<div className={styles.details}>
					<div className={styles.man}>{data.title || ""}</div>
					{/* <div className={styles.login}>@chelsiehaly</div> */}
				</div>
			</div>
			<div className={styles.btns}>
				<button
					className={cn("button-stroke", styles.button)}
					onClick={() => onClose()}
				>
					<span>Cancel</span>
					<Icon name="arrow-left" size="24" />
				</button>

				{gotoStripe ? (
					<a
						className={cn("button", styles.button)}
						href="https://dashboard.stripe.com"
						target="_blank"
					>
						Go to Stripe
					</a>
				) : (
					<button className={cn("button", styles.button)} onClick={save}>
						{loading && <Loader />}
						<span>Save</span>
						<Icon name="edit" size="24" />
					</button>
				)}
			</div>
		</div>
	);
};

export default Head;
